import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cloudfile",
  "use": "icon-cloudfile-usage",
  "viewBox": "0 0 49 48",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49 48\" id=\"icon-cloudfile\">\r\n  <g id=\"icon-cloudfile_编组\">\r\n    <path d=\"M2.94225 0.0037L35.2972 0.0037L48.0309 12.2477L48.0309 44.5717C47.9249 46.4194 46.4503 47.8941 44.6026 48L2.94225 48C1.20018 48 0.0037 46.3138 0.0037 44.5717L0.0037 2.94225C-0.0369963 2.15112 0.259509 1.37981 0.81966 0.81966C1.37981 0.259509 2.15112 -0.0369963 2.94225 0.0037Z\" id=\"icon-cloudfile_路径\" fill=\"#B5C3E3\" fill-rule=\"evenodd\" stroke=\"none\" />\r\n    <path d=\"M0.0037 0L12.7374 12.244L2.94225 12.244C2.15112 12.2847 1.37981 11.9881 0.81966 11.428C0.259509 10.8678 -0.0369963 10.0965 0.0037 9.30541L0.0037 0Z\" transform=\"translate(35.293457 0.0037231445)\" id=\"icon-cloudfile_路径\" fill=\"#A1ADC9\" fill-rule=\"evenodd\" stroke=\"none\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cloudfile.svg
// module id = 00qg
// module chunks = 15 16